import {FC} from 'react'
import {GChip} from 'src/app/components/Libs'
import {GChipProps} from 'src/app/components/Libs/Chip/Chip.types'
import {EJobPriority, EJobProgress} from 'src/app/models/Job/Job.model'

type TChip = {
  variant: GChipProps['variant']
  label: string
}

export const ChipStatusJob: FC<{status: boolean}> = ({status}) => {
  return (
    <GChip variant={status ? 'success' : 'neutral'} className='rounded-lg'>
      {status ? 'Aktif' : 'Tidak aktif'}
    </GChip>
  )
}

export const ChipProgressJob: FC<{status: keyof typeof EJobProgress}> = ({status}) => {
  const statusMap: Record<keyof typeof EJobProgress, TChip> = {
    SCHEDULED: {variant: 'neutral', label: 'Terjadwal'},
    OPEN: {variant: 'primary', label: 'Terbuka'},
    CLOSED: {variant: 'success', label: 'Selesai'},
    REJECTED: {variant: 'danger', label: 'Ditolak'},
    COMPLETED: {variant: 'secondary', label: 'Menunggu Persetujuan'},
    IN_PROGRESS: {variant: 'warning', label: 'Berlangsung'},
    DRAFT: {variant: 'neutral', label: 'Draf'},
    SUBMITTED: {variant: 'warning', label: 'Berlangsung'},
  }

  const currentStatus = statusMap[status]

  return currentStatus ? (
    <GChip variant={currentStatus.variant} className='rounded-lg'>
      {currentStatus.label}
    </GChip>
  ) : null
}

export const ChipProgressListJob: FC<{status: keyof typeof EJobProgress}> = ({status}) => {
  const statusMap: Record<keyof typeof EJobProgress, TChip> = {
    SCHEDULED: {variant: 'neutral', label: 'Terjadwal'},
    OPEN: {variant: 'primary', label: 'Terbuka'},
    COMPLETED: {variant: 'secondary', label: 'Menunggu Persetujuan'},
    CLOSED: {variant: 'success', label: 'Selesai'},
    REJECTED: {variant: 'success', label: 'Selesai'},
    IN_PROGRESS: {variant: 'warning', label: 'Berlangsung'},
    SUBMITTED: {variant: 'warning', label: 'Berlangsung'},
    DRAFT: {variant: 'neutral', label: 'Draf'},
  }

  const currentStatus = statusMap[status]

  return currentStatus ? (
    <GChip variant={currentStatus.variant} className='rounded-lg'>
      {currentStatus.label}
    </GChip>
  ) : null
}

export const ChipPriorityJob: FC<{status: keyof typeof EJobPriority}> = ({status}) => {
  const statusMap: Record<keyof typeof EJobPriority, TChip> = {
    LOW: {variant: 'neutral', label: 'Rendah'},
    NORMAL: {variant: 'primary', label: 'Normal'},
    HIGH: {variant: 'warning', label: 'Tinggi'},
    CRITICAL: {variant: 'danger', label: 'Kritis'},
  }

  const currentStatus = statusMap[status]

  return currentStatus ? (
    <GChip variant={currentStatus.variant} className='rounded-lg'>
      {currentStatus.label}
    </GChip>
  ) : null
}
